import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PackageService } from './package.service';
import { DtoFeature, DtoMetric, DtoModule, DtoPackage, DtoPreviewItem, DtoSubCategory, PackagePayload } from '../../../models/package-center.model';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { Controls, MatDialogCloseEvent, Mode, Role } from '../../../const';
import { Tabs } from '../package-center.component';
import { ProdetailsModalComponent } from '../../data-management/prodetails-modal/prodetails-modal.component';
import { Router } from '@angular/router';
import { SharedService } from '../../../shared/services/shared.service';


export enum OpenedFromType { 
  Package = 1, 
  MatAccount = 2, 
  SwapPackage = 3, 
  RequestToChangePackage = 4, 
  Notification = 5, 
  RequestToChangeAdmin = 6, 
  SwapPackageForAdmin = 7,
  DataAlerts = 8 }
export enum PackageType { RequestToUpgrade = 1, RequestedToUpgradeWithCustomization = 2, RequestedToCreateNewPackage = 3 }

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html'
})
export class PackageComponent implements OnInit, OnChanges {
  @Output() updateAssignedPackage = new EventEmitter<number>();
  @Output() hideGlobalCreate = new EventEmitter<boolean>();
  @Output() setPageTitle = new EventEmitter<{}>();
  @Output() close = new EventEmitter<void>();
  @Input() showForm: boolean = false;
  @Input() completedSwapPackage: boolean = false;
  @Input() isCurrentTab: string = "";
  @Input() openedFrom: number = 1;
  @Input() notificationId: number = 1;
  @Input() packageType: number = 0;
  @Output() packageActionTriggered = new EventEmitter<boolean>();
  @Output() packageAssigned = new EventEmitter<number>();
  @Output() requestToUpdatePackage = new EventEmitter<PackagePayload>();

  @Input() set selectedPackage(value: number) {
    this._selectedPackageId = value;
    if (this.packages && this.packages.length > 0 && this.openedFrom != this.openedFromType.RequestToChangeAdmin) {
      this.updateSelectedElement();
    }
  }
  get selectedPackage(): number {
    return this.selectedElement ? this.selectedElement.packageId : null!;
  }

  private _selectedPackageId: number | null = null;
  selectedElement: DtoPackage = {} as DtoPackage;
  packageControl = Controls;
  openedFromType = OpenedFromType;
  existingPackage: DtoPackage = {} as DtoPackage;
  packageForm: FormGroup = new FormGroup({
    
    existingPackageName: new FormControl(''),
    packageName: new FormControl('', [
      Validators.required
    ]),
    newPackageName: new FormControl(''),
    totalRoleCount: new FormControl(1, [
      Validators.required
    ]),

    existingFeatures: new FormControl([]),
    features: new FormControl([]),

    existingModules: new FormControl([]),
    modules: new FormControl([], [
      Validators.required
    ]),

    existingSubCategories: new FormControl([]),
    subCategories: new FormControl([], [
      Validators.required
    ]),

    metrics: new FormControl([])
  });

  features: DtoFeature[] = [];
  groupedFeatures: { [key: string]: DtoFeature[] } = {};
  selectedGroupedFeatures: { [key: string]: DtoFeature[] } = {};
  groupedExistingFeatures: { [key: string]: DtoFeature[] } = {};
  existingFeatures: DtoFeature[] = [];

  modules: DtoModule[] = [];
  subCategories: DtoSubCategory[] = [];
  groupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  selectedGroupedSubcategories: { [key: string]: DtoSubCategory[] } = {};
  groupedExistingSubcategories: { [key: string]: DtoSubCategory[] } = {};

  existingSubcategories: DtoSubCategory[] = [];
  subCategoriesForCreate: DtoSubCategory[] = [];
  packages: DtoPackage[] = [];
  allPackages: DtoPackage[] = [];
  isEdit: boolean = false;
  packageToEdit: DtoPackage = {} as DtoPackage;
  tabs = Tabs
  selectedRow: number = 0;
  newlySelectedRow: number = 0;
  userRole: string[] = [];
  roles = Role;
  showNewPackageDetails: boolean = false;

  constructor(private packageService: PackageService,
    private toasterService: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.getFeatures()
    this.getPackages()
    this.getModules();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openedFrom']?.currentValue == OpenedFromType.SwapPackageForAdmin) {
      this.packages = this.allPackages;
    }
    if (changes['completedSwapPackage']?.currentValue) {
      this.getPackages();
      this.openedFrom = this.openedFromType.RequestToChangeAdmin;
      this._selectedPackageId = this.newlySelectedRow;
      this.newlySelectedRow = 0;
      this.close.emit();
    }
  }

  showCreateForm() {
    this.packageForm.reset();
    this.setPageTitle.emit(
      {
        tab: this.tabs.Package,
        mode: Mode.Create
      }
    );
    this.showForm = true;
    this.isEdit = false;
  }

  closeCreateForm() {
    this.subCategories = this.subCategoriesForCreate;
    this.packageForm.reset();
    this.showForm = false;
    this.showNewPackageDetails = false;
    this.close.emit();
    this.isEdit = false;
    this.packageActionTriggered.emit(true);
    if (this.openedFrom == this.openedFromType.RequestToChangePackage || this.openedFrom == this.openedFromType.Notification) {
      this.getPackages();
    }
  }

  undoChangePackage() {
    this.openedFrom = this.openedFromType.RequestToChangeAdmin;
    this.newlySelectedRow = 0;
    this.packages = this.packages.filter((x: DtoPackage) => x.packageId != this._selectedPackageId);
    this.close.emit();
  }

  getPackages() {
    let sectorId = Number(sessionStorage.getItem('sector'));
    this.packageService.getPackages(sectorId, this.openedFrom == this.openedFromType.Notification ? 0 : 1).subscribe((response: DtoPackage[] | any) => {
      this.packages = response;
      this.allPackages = response;
      this.packageForm.reset();
      if (this._selectedPackageId !== null) {
        this.updateSelectedElement();
        if (this.openedFrom == this.openedFromType.RequestToChangeAdmin) {
          this.packages = this.packages.filter((x: DtoPackage) => x.packageId != this._selectedPackageId);
        }
        if (this.openedFrom == this.openedFromType.RequestToChangePackage) {
          this.packages = this.packages.filter((x: DtoPackage) => x.packageId != this._selectedPackageId);
          this.packages.unshift({
            packageId: -1,
            packageName: "Request New Package"
          } as DtoPackage)
          this.existingPackage = response.find((x: DtoPackage) => x.packageId == this._selectedPackageId);
          this.packageForm.controls['existingPackageName'].setValue(this.existingPackage?.packageName);
          this.packageForm.controls['existingPackageName'].disable();
          this.packageForm.controls['newPackageName'].setValidators([Validators.required]);
          this.editPackage(this.existingPackage, this.openedFromType.RequestToChangePackage);
        }
        if (this.openedFrom == this.openedFromType.Notification) {
          let packageToApprove = response.find((x: DtoPackage) => x.packageId == this._selectedPackageId);
          this.packageType = this.packageType - 1;
          this.editPackage(packageToApprove, this.openedFromType.Notification);
          return;
        }
      }
      if (!this.packages.length) {
        this.hideGlobalCreate.emit(true)
      }
      this.isEdit = false;
      this.showForm = false;
      this.close.emit();
    }, (err: HttpErrorResponse) => {
      if (err.error) {
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  updatePackage() {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: false,
        message: "If you update the package, the corresponding roles created with respect to this package will be affected.  Are you sure, you want to continue?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.updateAssignedPackage.emit(this.newlySelectedRow);
        this.getPackages();
        this.openedFrom = this.openedFromType.RequestToChangeAdmin;
        this.close.emit();
      }
    });
  }

  filter(packages: DtoPackage[]) {
    if (this.openedFrom == this.openedFromType.RequestToChangePackage) {
      packages = packages.filter((x: DtoPackage) => x.packageId != this._selectedPackageId)
    }
    return packages.filter((x: DtoPackage) => x.packageId != -1);
  }

  private updateSelectedElement() {
    this.selectedElement = this.packages.find(x => x.packageId == this._selectedPackageId)!;
    this.selectedRow = this._selectedPackageId!;
    this.packageAssigned.emit(this.selectedRow);
  }

  getFeatures(): void {
    const sectorId = Number(sessionStorage.getItem('sector'));

    this.packageService.getAllFeatures(sectorId).subscribe({
      next: (response: DtoModule[] | any) => {
        this.features = response;
        this.groupedFeatures = this.generateSelectedFeatures(this.features);
      },
      error: (err: HttpErrorResponse) => {
        if (err.error) {
          this.toasterService.error(err.error, 'Error');
        }
      }
    });

  }


  getModules() {
    let sectorId = Number(sessionStorage.getItem('sector'));
    this.packageService.getModules(sectorId).subscribe({
      next: (response: DtoModule[] | any) => {
        this.modules = response;
      },
      error: (err: HttpErrorResponse) => {
        if (err.error) {
          this.toasterService.error(err.error, 'Error');
        }
      }
    });
  }
  
  generateSelectedFeatures(selectedValues: DtoFeature[]):{ [key: string]: DtoFeature[] } {
    if (!selectedValues || selectedValues.length === 0) {
      return {};
    }

    const groupedValues = selectedValues.reduce((result, sc) => {
      const key = sc.featureSetName!;
      result[key] = result[key] || [];
      result[key].push(sc);
      return result;
    }, {} as { [key: string]: DtoFeature[] });

    return groupedValues;
  }

  generateSelectedCategoryModules(selectedValues: DtoSubCategory[]) {
    if (!selectedValues || selectedValues.length === 0) {
      return {};
    }


    const groupedValues = selectedValues.reduce((result, sc) => {
      const key = sc.moduleDisplayName!;
      result[key] = result[key] || [];
      result[key].push(sc);
      return result;
    }, {} as { [key: string]: DtoSubCategory[] });

    return groupedValues;
  }

  onModuleChange(selectedModule: any) {
    let payload = selectedModule.value;
    this.packageService.getSubCategories(payload).subscribe((response: DtoSubCategory[] | any) => {
      this.subCategories = response;
      this.subCategoriesForCreate = this.subCategories;

      let subCategoryList = this.subCategories.filter(subCategory => {
        return this.packageForm.controls['subCategories'].value?.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
      });

      this.packageForm.controls['subCategories'].setValue(subCategoryList);
      this.selectedGroupedSubcategories = this.generateSelectedCategoryModules(subCategoryList);

      this.groupedSubCategories = (this.subCategories ?? []).reduce((result, sc) => {
        const key = sc.moduleDisplayName!;
        result[key] = result[key] || [];
        result[key].push(sc);
        return result;
      }, {} as { [key: string]: DtoSubCategory[] });

    }, (err: HttpErrorResponse) => {
      if (err.error) {
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  async createPackage(): Promise<any> {
    let payload: PackagePayload = JSON.parse(JSON.stringify(this.packageForm.value))
    
    if (this.notificationId && this.notificationId > 0) {
      payload.notificationId = this.notificationId;
      payload.assignPackage = this.openedFrom == this.openedFromType.Notification;
    }

    if (payload.totalRoleCount < this.packageToEdit.totalRoleCount!) {
      //Check if the subscribers of this package can be accomodated if the subscription count is reduced
      try {
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.packageToEdit.packageId);
        let activeSubscriptions = this.packageToEdit.totalRoleCount! - numberOfSubscriptionAvailable;

        if (activeSubscriptions > payload.totalRoleCount) {
          this.toasterService.error(`Package has been already subscribed to ${activeSubscriptions} subscribers. Unable to reduce the subscription count.`);
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }
    }

    if (this.isEdit) {
      this.dialog.open(ConfirmComponent, {
        width: '375px',
        data: {
          status: false,
          message: "If you update the package, the corresponding roles created with respect to this package will be affected.  Are you sure, you want to continue?"
        }
      }).afterClosed().subscribe((popupEvent: any) => {
        if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
          payload.packageId = this.packageToEdit.packageId;
          payload.assignPackage = this.openedFrom == this.openedFromType.Notification;
          payload.packageType = this.openedFromType.Notification ? this.packageType : 0;
          this.packageService.updatePackage(payload).subscribe((res => {
            if (this.openedFrom == this.openedFromType.Notification) {
              this.router.navigate(['/notifications']);
              this.toasterService.success("Package upgraded successfully", "Success");
              this.packageActionTriggered.emit(true);
              return;
            }
            this.toasterService.success("Package updated successfully", "Success");
            this.packageActionTriggered.emit(true);
            this.getPackages();
          }), (error: HttpErrorResponse) => {
            if (error.error) {
              this.toasterService.error(error.error, "Error");
            }
          })
        }
      });
      return;
    };
      
    this.packageService.createPackage(payload).subscribe({
      next: (response) => {
        if (response) {
          this.toasterService.success(
            'Package created successfully',
            'Success'
          );
          this.packageActionTriggered.emit(true);
          this.getPackages();
        }
      },
      error: (error: HttpErrorResponse) => {
        if (error.error) {
          this.toasterService.error(error.error, 'Error');
        }
      }
    });
  }

  async onRowClick(rowId: number): Promise<any> {
    this.selectedRow = rowId;
    this.packageAssigned.emit(rowId);
    this.newlySelectedRow = this.openedFrom == this.openedFromType.SwapPackageForAdmin ? rowId : 0;
  }

  editPackage(packageDetails: DtoPackage, openedFrom: number = 0) {
    if (packageDetails.packageId == -1) {
      this.showForm = true;
      this.showNewPackageDetails = true;
      return;
    }
    if (openedFrom != this.openedFromType.Notification) {
      this.packageActionTriggered.emit(false);
    }
    this.isEdit = true;
    this.sharedService.setIsEdit(this.isEdit);
    this.showForm = true;
    this.setPageTitle.emit({
      tab: this.tabs.Package,
      mode: Mode.Edit
    })
    this.packageToEdit = packageDetails
    let subCategoriesToConsider: DtoSubCategory[] = [];

    this.packageService.getSubCategories(packageDetails.modules).subscribe({
      next: (res: DtoSubCategory[] | any) => {
        if (openedFrom === this.openedFromType.RequestToChangePackage) {
          subCategoriesToConsider = res;
          this.existingSubcategories = res;
          this.groupedExistingSubcategories =
            this.generateSelectedCategoryModules(this.existingSubcategories);
        } else {
          subCategoriesToConsider = res;
          this.subCategories = res;
        }

        const featureList = this.features.filter(feature =>
          packageDetails.features.some(
            featureModule => feature.featureId === featureModule.featureId
          )
        );

        const moduleList = this.modules.filter(module =>
          packageDetails.modules.some(
            packageModule => module.moduleId === packageModule.moduleId
          )
        );

        const subCategoryList = subCategoriesToConsider.filter(subCategory =>
          packageDetails.subCategories.some(
            packageSubCategory =>
              subCategory.subCategoryId === packageSubCategory.subCategoryId
          )
        );

        this.packageForm.patchValue({
          packageName:
            openedFrom === this.openedFromType.Notification
              ? ''
              : packageDetails.packageName,

          totalRoleCount: packageDetails.totalRoleCount,

          features:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? []
              : featureList,

          modules:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? []
              : moduleList,

          subCategories:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? []
              : subCategoryList,

          existingFeatures:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? featureList
              : [],

          existingModules:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? moduleList
              : [],

          existingSubCategories:
            openedFrom === this.openedFromType.RequestToChangePackage
              ? subCategoryList
              : []
        });

        this.groupedExistingFeatures =
          this.generateSelectedFeatures(this.existingFeatures);

        this.selectedGroupedFeatures =
          this.generateSelectedFeatures(featureList);

        this.groupedFeatures =
          this.generateSelectedFeatures(this.features);

        this.groupedExistingSubcategories =
          this.generateSelectedCategoryModules(this.existingSubcategories);

        this.selectedGroupedSubcategories =
          this.generateSelectedCategoryModules(subCategoryList);

        this.groupedSubCategories = (this.subCategories ?? []).reduce(
          (result, sc) => {
            const key = sc.moduleDisplayName!;

            result[key] = result[key] || [];
            result[key].push(sc);

            return result;
          },
          {} as { [key: string]: DtoSubCategory[] }
        );
      },

      error: (err: HttpErrorResponse) => {
        if (err.error) {
          this.toasterService.error(err.error, 'Error');
        }
      }
    });

  }

  deletePackage(packageDetails: DtoPackage) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the package?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.packageService.deletePackage(packageDetails.packageId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Package deleted successfully!", "Success");
            this.getPackages();
          }
        }, (error: HttpErrorResponse) => {
          if (error.error) {
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    });
  }

  previewPopup(title: string, control: string, packageDetails: DtoPackage = {} as DtoPackage) {

    this.dialog.open(ProdetailsModalComponent, {
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: title ? true : false,
        packageDetails: packageDetails,
        itemToPreview: this.getPreviewData(control),
        title: title ? title : (packageDetails.packageName ?? 'New') + " Details"
      }
    })
  }

  getPreviewData(control: string): DtoPreviewItem[] {
    switch (control) {
      case this.packageControl.Feature:
        return this.openedFrom == this.openedFromType.RequestToChangePackage ?
          this.packageForm.controls['existingFeatures'].value.map((x: DtoFeature) => ({
            groupName: x.featureSetName,
            itemName: x.featureName
          }))
          :
          this.packageForm.controls['features'].value.map((x: DtoFeature) => ({
            groupName: x.featureSetName,
            itemName: x.featureName
          }));
      case this.packageControl.Module:
        return this.openedFrom == this.openedFromType.RequestToChangePackage ?
          this.packageForm.controls['existingModules'].value.map((x: DtoModule) => ({
            groupName: null,
            itemName: x.moduleName
          }))
          :
          this.packageForm.controls['modules'].value.map((x: DtoModule) => ({
            groupName: null,
            itemName: x.moduleName
          }));
      case this.packageControl.SubCategory:
        return this.openedFrom == this.openedFromType.RequestToChangePackage ?
          this.packageForm.controls['existingSubCategories'].value.map((x: DtoSubCategory) => ({
            groupName: x.moduleDisplayName,
            itemDisplay: x.subCategoryDisplayName,
            itemName: x.subCategoryName
          } as DtoPreviewItem))
          :
          this.packageForm.controls['subCategories'].value.map((x: DtoSubCategory) => ({
            groupName: x.moduleDisplayName,
            itemName: x.subCategoryName,
            itemDisplay: x.subCategoryDisplayName
          } as DtoPreviewItem));

      case this.packageControl.Metrics:
        return this.packageForm.controls['metrics'].value.map((x: DtoMetric) => ({
          groupName: null,
          itemName: x.metricName
        }));
      default:
        return [];
    }
  }

  removeFeature(featureToRemove: DtoFeature) {
    const newValue = this.packageForm.controls['features'].value.filter((x: DtoFeature) => x.featureId != featureToRemove.featureId)
    this.packageForm.controls['features'].setValue(newValue);
    this.selectedGroupedFeatures = this.generateSelectedFeatures(newValue);
  }

  removeModule(moduleToRemove: DtoModule) {
    this.packageForm.controls['modules'].setValue(this.packageForm.controls['modules'].value.filter((x: DtoModule) => x.moduleId != moduleToRemove.moduleId));
    this.onModuleChange({ value: this.packageForm.controls['modules'].value });
  }

  removeSubCategory(SubCategoryToRemove: DtoSubCategory) {
    const newValue = this.packageForm.controls['subCategories'].value.filter((x: DtoSubCategory) => x.subCategoryId != SubCategoryToRemove.subCategoryId);

    this.packageForm.controls['subCategories'].setValue(newValue);
    this.selectedGroupedSubcategories = this.generateSelectedCategoryModules(newValue);
  }

  removeMetric(metricToRemove: DtoMetric) {
    return this.packageForm.controls['metrics'].setValue(this.packageForm.controls['metrics'].value.filter((x: DtoMetric) => x.metricId != metricToRemove.metricId))
  }

  activateDeactivatePackage(packageDetails: DtoPackage) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: packageDetails.status,
        message: "Are you sure want to" + (packageDetails.status ? " inactivate" : " activate") + " the package?"
      }
    }).afterClosed().subscribe((popupEvent: any) => {
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.packageService.updatePackageStatus(packageDetails.packageId).subscribe((res) => {
          if (res) {
            this.toasterService.success("Package" + (packageDetails.status ? " activated" : " inactivated") + " successfully", "Success");
            this.getPackages();
          }
        }, (error: HttpErrorResponse) => {
          if (error.error) {
            this.toasterService.error(error.error, "Error");
          }
          packageDetails.status = !packageDetails.status;
        })
      }
      else {
        packageDetails.status = !packageDetails.status;
      }
    });
  }

  async requestToChangePackage(): Promise<any> {
    if (this.packageForm.controls['modules'].value.length && !this.packageForm.controls['subCategories'].value.length) {
      this.toasterService.error("Please select at least one Analytics Toolkit to proceed", "Error");
      return;
    }

    let featuresToConsider = this.packageForm.controls['newPackageName'].value.packageId == -1 ?
      this.packageForm.controls['features'].value :
      this.packageForm.controls['existingFeatures'].value.concat(this.packageForm.controls['features'].value);
    this.selectedGroupedFeatures = this.generateSelectedFeatures(featuresToConsider);

    let modulesToConsider = this.packageForm.controls['newPackageName'].value.packageId == -1 ?
      this.packageForm.controls['modules'].value :
      this.packageForm.controls['existingModules'].value.concat(this.packageForm.controls['modules'].value);
    let subCategoriesToConsider = this.packageForm.controls['newPackageName'].value.packageId == -1 ?
      this.packageForm.controls['subCategories'].value :
      this.packageForm.controls['subCategories'].value.concat(this.packageForm.controls['existingSubCategories'].value);
    this.selectedGroupedSubcategories = this.generateSelectedCategoryModules(this.packageForm.controls['subCategories'].value);
   

    let packageDetails: PackagePayload = {
      features:[...new Map(featuresToConsider.map((item: any) => [item['featureid'], item])).values()],
      modules: [...new Map(modulesToConsider.map((item: any) => [item['moduleId'], item])).values()],
      subCategories: [...new Map(subCategoriesToConsider.map((item: any) => [item['subCategoryId'], item])).values()],
      packageType:
        this.packageForm.controls['newPackageName'].value.packageId == -1 ? PackageType.RequestedToCreateNewPackage :
          this.packageForm.controls['modules'].value.length ? PackageType.RequestedToUpgradeWithCustomization : PackageType.RequestToUpgrade,
      requestedPackage: true,
      fromPackageId: this.existingPackage.packageId,
      toPackageId: this.packageForm.controls['newPackageName'].value.packageId
    } as unknown as PackagePayload;
    this.requestToUpdatePackage.emit(packageDetails);
  }
}
